import React, { useEffect, useMemo, useRef, useState } from "react";
import { Galleria } from "primereact/galleria";

const Gallery = () => {
  const videoRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  const slides = useMemo(
    () => [
      {
        type: "video",
        src: `${process.env.PUBLIC_URL}/images/videos/VID_MK_DIGITAL.mp4`,
        alt: "Video principal",
      },
      {
        type: "image",
        src: `${process.env.PUBLIC_URL}/images/imagen1-carrucel.png`,
        alt: "Imagen 1",
        onClick: () =>
          window.open(
            "https://admision.unicach.mx/cadmision2026/?tag=fd7af9eec4cfbbfdbbdc8d635b48c08cLU1LVA==",
            "_blank"
          ),
      },
    ],
    []
  );

  useEffect(() => {
    let interval;

    if (activeIndex !== 0) {
      interval = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % slides.length);
      }, 4000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [activeIndex, slides.length]);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    if (activeIndex === 0) {
      video.muted = isMuted;

      if (!isPaused) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      }
    } else {
      video.pause();
    }
  }, [activeIndex, isMuted, isPaused]);

  const handleVideoEnd = () => {
    setIsPaused(false);
    setActiveIndex(1);
  };

  const toggleMute = (e) => {
    e.stopPropagation();

    const video = videoRef.current;
    const newMutedState = !isMuted;

    setIsMuted(newMutedState);

    if (video) {
      video.muted = newMutedState;
    }
  };

  const togglePause = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => setIsPaused(false))
          .catch(() => {});
      } else {
        setIsPaused(false);
      }
    } else {
      video.pause();
      setIsPaused(true);
    }
  };

  const itemTemplate = (item) => {
    if (item.type === "video") {
      return (
        <div
          style={{
            width: "100%",
            overflow: "hidden",
            position: "relative",
            cursor: "pointer",
          }}
          onClick={togglePause}
        >
          <video
            ref={videoRef}
            src={item.src}
            onEnded={handleVideoEnd}
            muted={isMuted}
            autoPlay
            playsInline
            controls={false}
            style={{
              width: "100%",
              height: "clamp(200px, min(60vh, 80vw * 0.5625), 720px)",
              aspectRatio: "16 / 9",
              objectFit: "cover",
              display: "block",
              backgroundColor: "#000",
            }}
          />

          <button
            type="button"
            onClick={toggleMute}
            style={{
              position: "absolute",
              right: "20px",
              bottom: "20px",
              zIndex: 10,
              background: "rgba(0,0,0,0.65)",
              color: "#fff",
              border: "none",
              borderRadius: "999px",
              padding: "10px 16px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            {isMuted ? "Activar audio" : "Desactivar audio"}
          </button>

          {isPaused && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(0,0,0,0.2)",
                zIndex: 9,
                pointerEvents: "none",
              }}
            >
              <div
                style={{
                  background: "rgba(0,0,0,0.65)",
                  color: "#fff",
                  padding: "14px 22px",
                  borderRadius: "999px",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                Reanudar
              </div>
            </div>
          )}
        </div>
      );
    }

    return (
      <div style={{ width: "100%", overflow: "hidden" }}>
        <img
          src={item.src}
          alt={item.alt}
          onClick={item.onClick}
          style={{
            width: "100%",
            height: "clamp(200px, min(60vh, 80vw * 0.5625), 720px)",
            aspectRatio: "16 / 9",
            objectFit: "cover",
            display: "block",
            cursor: item.onClick ? "pointer" : "default",
            transition: item.onClick ? "transform 0.3s ease" : "none",
          }}
          onMouseEnter={(e) => {
            if (item.onClick) e.currentTarget.style.transform = "scale(1.02)";
          }}
          onMouseLeave={(e) => {
            if (item.onClick) e.currentTarget.style.transform = "scale(1)";
          }}
          onError={(e) => {
            e.currentTarget.src = "https://dummyimage.com/600x400/000/fff";
          }}
        />
      </div>
    );
  };

  return (
    <section className="w-full flex justify-content-center">
      <div className="w-full" style={{ maxWidth: "100%", overflow: "hidden" }}>
        <Galleria
          value={slides}
          activeIndex={activeIndex}
          onItemChange={(e) => setActiveIndex(e.index)}
          style={{
            width: "100%",
            maxHeight: "800px",
          }}
          responsiveOptions={[
            {
              breakpoint: "1024px",
              numVisible: 1,
            },
            {
              breakpoint: "768px",
              numVisible: 1,
            },
            {
              breakpoint: "480px",
              numVisible: 1,
            },
          ]}
          showThumbnails={false}
          showIndicators
          showIndicatorsOnItem
          indicatorsPosition="bottom"
          item={itemTemplate}
          circular
          showItemNavigators
          autoPlay={false}
        />
      </div>
    </section>
  );
};

export default Gallery;